import { required } from "vuelidate/lib/validators";

export default class ProdutosValorData {
  id_kit = 1729;

  qtd = 1;

  valor = 0;

  id_tipo_cliente = 1;

  constructor({ qtd = 1, id_kit = 1729, valor = 0, id_tipo_cliente = 1 }) {
    this.id_kit = id_kit;
    this.valor = valor;
    this.qtd = qtd;
    this.id_tipo_cliente = id_tipo_cliente;
  }
}

export const ProdutosValorDataRequired = {
  id_kit: {
    required,
  },
  qtd: {
    required,
  },
  valor: {
    required,
  },
  id_tipo_cliente: {
    required,
  },
};
